var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { align: "center" } },
    [
      _c(
        "v-flex",
        { attrs: { md10: "" } },
        [
          _c(
            "v-card",
            { staticClass: "rounded-card" },
            [
              _c(
                "v-form",
                {
                  ref: "form",
                  staticClass: "col-md-12",
                  attrs: { "lazy-validation": "" },
                  model: {
                    value: _vm.isFormValid,
                    callback: function($$v) {
                      _vm.isFormValid = $$v
                    },
                    expression: "isFormValid"
                  }
                },
                [
                  _c(
                    "v-container",
                    {
                      staticStyle: { padding: "30px 40px 50px 40px" },
                      attrs: { "grid-list-md": "" }
                    },
                    [
                      _c(
                        "FormFieldsContainer",
                        { attrs: { titulo: "Información General" } },
                        [
                          _vm._t("prependInformacionGeneral"),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm12: "", md12: "" } },
                            [
                              _c("v-switch", {
                                attrs: {
                                  label:
                                    _vm.formFields.activo.value == 1
                                      ? "Activo"
                                      : "Inactivo",
                                  color: "#FDEF68",
                                  "persistent-hint": "",
                                  hint: _vm.warningInactivo,
                                  readonly: _vm.modoVer
                                },
                                model: {
                                  value: _vm.formFields.activo.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.activo,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.activo.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { x12: "", sm12: "", md12: "" } },
                            [
                              _c("v-text-field", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required|max:80|NombreUnico",
                                    expression: "'required|max:80|NombreUnico'"
                                  }
                                ],
                                attrs: {
                                  label: _vm.formFields.nombre.label,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.nombre.id
                                  ),
                                  "data-vv-name": _vm.formFields.nombre.id,
                                  counter: "80",
                                  disabled: _vm.modoVer
                                },
                                model: {
                                  value: _vm.formFields.nombre.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.nombre,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.nombre.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm12: "", md12: "" } },
                            [
                              _c("v-text-field", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value:
                                      "required|max:10|rut|rutFormato|RutUnico",
                                    expression:
                                      "'required|max:10|rut|rutFormato|RutUnico'"
                                  }
                                ],
                                attrs: {
                                  label: _vm.formFields.rut.label,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.rut.id
                                  ),
                                  "data-vv-name": _vm.formFields.rut.id,
                                  counter: "10",
                                  disabled: _vm.modoVer || _vm.nuncaEdit
                                },
                                model: {
                                  value: _vm.formFields.rut.value,
                                  callback: function($$v) {
                                    _vm.$set(_vm.formFields.rut, "value", $$v)
                                  },
                                  expression: "formFields.rut.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm12: "", md12: "" } },
                            [
                              _c("v-select", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required",
                                    expression: "'required'"
                                  }
                                ],
                                attrs: {
                                  label: _vm.formFields.giro.label,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.giro.id
                                  ),
                                  "data-vv-name": _vm.formFields.giro.id,
                                  items: _vm.lstGiros,
                                  "item-text": "nombre",
                                  "item-value": "id",
                                  disabled: _vm.modoVer
                                },
                                model: {
                                  value: _vm.formFields.giro.value,
                                  callback: function($$v) {
                                    _vm.$set(_vm.formFields.giro, "value", $$v)
                                  },
                                  expression: "formFields.giro.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { x12: "", sm12: "", md12: "" } },
                            [
                              _c("v-text-field", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "max:250",
                                    expression: "'max:250'"
                                  }
                                ],
                                attrs: {
                                  label: _vm.formFields.direccion.label,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.direccion.id
                                  ),
                                  "data-vv-name": _vm.formFields.direccion.id,
                                  counter: "250",
                                  disabled: _vm.modoVer
                                },
                                model: {
                                  value: _vm.formFields.direccion.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.direccion,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.direccion.value"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        2
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }